import { createContext, useContext } from "react";

const ViewInsetContext = createContext<string | null>(null);

/** Gives the pages inside a view inset from the viewport, such as settings' panel, its gap from each viewport edge as a CSS length. */
export const ViewInsetProvider = ViewInsetContext.Provider;

/** The gap between the view a page fills and each viewport edge, `0px` outside an inset view. Fixed elements add it to stay inside the view. */
export const useViewInset = () => useContext(ViewInsetContext) ?? "0px";

/** The height of the view a page fills: an inset view's, or `viewportHeight` outside one. */
export const useViewHeight = (viewportHeight = "100dvh") => {
  const inset = useContext(ViewInsetContext);
  return inset ? `calc(100dvh - 2 * ${inset})` : viewportHeight;
};
